<template>
  <ItcIndex v-if="loginScene == 2" />
  <HuiyiIndex v-else-if="loginScene == 1" />
</template>

<script>
import ItcIndex from "./itc-index";
import HuiyiIndex from "./huiyi-index";
export default {
  components: {
    ItcIndex,
    HuiyiIndex,
  },
  data() {
    return {
      loginScene: parseInt(
        sessionStorage.getItem("isItcScene") || this.$store.getters.isItcScene
      ),
    };
  },
  created() {
    // 以防万一没有在加载页获取到场景时，重新获取场景
    this.getScene();
    this.getTitle();
  },
  methods: {
    getScene() {
      let success = (res) => {
        let number1 = res.data;
        sessionStorage.setItem("isItcScene", number1);
        this.$store.commit("SET_ISITCSCENCE", number1);
        this.loginScene = number1;
        if (number1) {
          // 修改element ui 主题颜色
          // this.toggleClass(document.body,'custom-E62125')
        } else {
          // this.toggleClass(document.body,'custom-409EFF')
        }
      };
      let fail = (res) => {
        console.log("fail", res);
      };
      this.$ajax.get("api/login/frontVersion", { func: { success, fail } });
    },
  },
};
</script>

<style lang="scss"></style>
